
import React, {useEffect} from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import ContentModule from "../../modules/content_module";
import { Link } from "gatsby"
import moment from "moment"
import "./Insight.scss";


const Insight = ({ title, content, breadcrumbs, tags, author, createdAt, className, post_on }) => {


    return (
        <React.Fragment>
            <section className={`insight-section ${className}`}>
                <Container>
                    <Row>
                        <Col>
                            <div className="breadcrumb-section">
                                <Breadcrumb>
                                    {/* <Breadcrumb.Item href="javascript:;" className="d-none">Back to Branch Details</Breadcrumb.Item> */}
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>
                                    {breadcrumbs?.map((breadcrumb, i, arr) => {
                                        if (arr.length - 1 === i) { // is the last item in the array
                                            return (
                                                <Breadcrumb.Item key={i} active>{breadcrumb.label}</Breadcrumb.Item>
                                            )
                                        } 
                                        else {
                                            return (
                                                <li className="breadcrumb-item"><Link to={`${breadcrumb.url}/`}>{breadcrumb.label}</Link></li>
                                            )
                                        }
                                    })}
                                </Breadcrumb>
                            </div>
                            <div className="content col-lg-8">
                                <h1>{title}</h1>
                                <ContentModule Content={content} />
                            </div>
                            <div className="news-author-details">
                                {post_on &&
                                    <div className="date list">
                                        <i className="icon-calendar"></i>
                                        <span>{moment(post_on).format('Do MMM YYYY')}</span>
                                    </div>
                                }

                                {author &&
                                    <div className="author list">
                                        <i className="icon-author"></i>
                                        <span>{author.name}</span>
                                    </div>
                                }

                                {tags &&
                                    <div className="tag list">
                                        <i className="icon-tag"></i>
                                        <span>{tags}</span>
                                    </div>
                                }

                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Insight;